export default __webpack_public_path__ + "static/media/IMG-activityPH_selfregulation.d184f62a.png";